/*
 * Project: Gulp Boilerplate by Orbital <https://gulp.netlify.com/>
 * Author: Wallace Erick <wallace.erick@orbitalcode.com.br>
 * Author URL: http://wallaceerick.com.br
 * Description: A base to start your project usign gulp.
 * Version: 0.0.6
*/
/*
 * Project: Gulp Boilerplate by Orbital <https://gulp.netlify.com/>
 * Author: Wallace Erick <wallace.erick@orbitalcode.com.br>
 * Author URL: http://wallaceerick.com.br
 * Description: A base to start your project usign gulp.
 * Version: 0.0.6
*/
var baseURLImagesUser = '';
var baseURLImagesPost = '';
var pageScrollCurrent = 1;

var hashStatusPrimary = 'e7198d9d-0c30-488f-8a94-c4ef01bc1e33',
	hashStatusSecondary = 'bee0e1e7-418c-4d71-9642-f7ed0ab9c24d',
	hashStatusTertiary = '0c7847ad-cc60-4ebc-812a-b6b6631fb816';

var hashStatusComentPrivate = 'EB000A91-AC20-48B3-A1BA-51D5B150FCA5',
	hashStatusComentPublic = 'E94456FF-709E-44AD-B7B4-602486404B24';


$(function () {
	Notification.init();
	Post.init();
	Scroll.init();
	userClient.init();
});

function escapeRegExp(string) {
	return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(str, find, replace) {
	return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

var Alert = {
	init: function (type, message) {
		var element = $('.js-alert.alert-' + type + '');
		if (!element[0]) {
			return false;
		}
		element.html(message).stop().fadeIn();
		window.setTimeout(function () {
			element.fadeTo(1000, 0).slideUp(1000, function () {
				$(this).remove();
			});
		}, 4000);
	}
}

var consultantList;
var consultantChanged;
var Consultant = {
	init: function () {
		this.get();
	},
	get: function () {
		var selfThis = this;
		$.ajax({
			type: "POST",
			url: "/Service.aspx/ListDealershipSalesConsultant",
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				consultantList = response.d;
				selfThis.constructorHTML(consultantList);
			}
		});
	},
	constructorHTML: function (paramList) {
		var element = $('.js-consultant-list');
		if (element[0]) {
			var htmlBlock = '';
			paramList.map(function (e) {
				var cssClassItem = e.in_group == 1 ? 'active ' : '',
					cssClassItemManager = e.is_manager == 1 ? ' active-x' : '';
				htmlBlock += '<div class="team__list--item"> \
					<a href="#" data-hash="' + e.user_hash + '" class="' + cssClassItem + cssClassItemManager + '"> \
						<img src="' + baseURLImagesUser + e.user_picture + '" alt="Profile" /> \
						<span> \
						' + e.user_name + ' \
						</span> \
						<svg class="svg icon"> \
							<use xlink:href="/Content/build/assets/images/svg.svg#check"></use> \
						</svg> \
						<span class="crown"> \
							<svg class="svg icon"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#crown"></use> \
							</svg> \
						</span>	\
					</a> \
				</div>';
			});
			element.html(htmlBlock);
			centralizeModal('#modalWhatsappConsultant');
			this.eventLinks(element);
		}
	},
	eventLinks: function (el) {
		var element = el,
			selfThis = this;
		if (!element[0]) {
			return false;
		}
		element.on('click', 'a', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			$(this).addClass('active').parent().siblings().find('a').removeClass('active');
			selfThis.changeConsultant($(this).attr('data-hash'));
			return false;
		});
		$('.js-consultant-search-ctrl').on('keyup', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			var searchValue = $(this).val();
			var filteredArray = consultantList.filter(function (i) {
				return i.user_name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
			});
			selfThis.constructorHTML(filteredArray);
		});
	},
	changeConsultant: function (paramHash) {
		consultantChanged = consultantList.filter(function (i) {
			return i.user_hash == paramHash;
		});
		//$('.js-consultant-mail-ctrl').val(consultantChanged[0].email);
	},
	save: function () {
		var elConsultantMailValue = $('.js-consultant-mail-ctrl').val();
		if (consultantChanged == '' || elConsultantMailValue == '') {
			return false;
		}
		$.ajax({
			type: "POST",
			url: "/Service.aspx/UpdateDealershipWhatsAppUser",
			data: '{"whatsapp_id": "' + consultantChanged[0].whatsapp_id + '", "user_hash": "' + consultantChanged[0].user_hash + '", "user_email": "' + elConsultantMailValue + '", "user_name": "' + consultantChanged[0].user_name + '" }',
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				//selfThis.constructorHTML(teamList);
				//Alert.init('success', 'Consultor atualizado com sucesso!');
				fechaModal('#modalWhatsappConsultant');
				$('#modalWhatsappResume').find('.lbl-email').html(response.d.email_return);
				$('#modalWhatsappResume').find('.lbl-name').html(response.d.name_return);
				abreModal('#modalWhatsappResume');
			}, error: function (response) {
				fechaModal('#modalWhatsappConsultant');
				Alert.init('danger', 'Ocorreu um erro. ' + response.Message);
			}
		});
	}
};

var teamList;
var Team = {
	init: function () {
		this.get();
	},
	get: function () {
		var selfThis = this;
		$.ajax({
			type: "POST",
			url: "/Service.aspx/ListDealershipGroup",
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				teamList = response.d;
				selfThis.constructorHTML(teamList);
			}
		});
	},
	save: function () {
		$.ajax({
			type: "POST",
			url: "/Service.aspx/InsertDelearshipUserGroup",
			data: '{"dealership_group_users": ' + JSON.stringify(teamList) + '}',
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				//selfThis.constructorHTML(teamList);
				fechaModal('#modalTeamEdit');
				Alert.init('success', 'Equipe atualizada com sucesso!');
				window.location.reload();
				// Alert.init('success', 'Equipe atualizada com sucesso!');
			}, error: function (response) {
				fechaModal('#modalTeamEdit');
				Alert.init('danger', 'Ocorreu um erro. ' + response.Message);
			}
		});
	},
	constructorHTML: function (paramList) {
		var element = $('.js-team-list');
		if (element[0]) {
			var htmlBlock = '';
			paramList.map(function (e) {
				var cssClassItem = e.in_group == 1 ? 'active ' : '',
					cssClassItemManager = e.is_manager == 1 ? ' active-x' : '';
				htmlBlock += '<div class="team__list--item"> \
					<a href="#" data-hash="' + e.user_hash + '" class="' + cssClassItem + cssClassItemManager + '"> \
						<img src="' + baseURLImagesUser + e.user_picture + '" alt="Profile" /> \
						<span> \
						' + e.user_name + ' \
						</span> \
						<svg class="svg icon"> \
							<use xlink:href="/Content/build/assets/images/svg.svg#check"></use> \
						</svg> \
						<span class="crown"> \
							<svg class="svg icon"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#crown"></use> \
							</svg> \
						</span>	\
					</a> \
				</div>';
			});
			element.html(htmlBlock);
			centralizeModal('#modalTeamEdit');
			this.eventLinks(element);
		}
	},
	eventLinks: function (el) {
		var element = el,
			selfThis = this;
		if (!element[0]) {
			return false;
		}
		element.on('click', 'a', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			$(this).toggleClass('active');
			selfThis.updateTeamList($(this).attr('data-hash'));
			return false;
		});
		$('.js-team-search-ctrl').on('keyup', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			var searchValue = $(this).val();
			var filteredArray = teamList.filter(function (i) {
				return i.user_name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
			});
			selfThis.constructorHTML(filteredArray);
		});
	},
	updateTeamList: function (p) {
		var filteredArray = teamList.filter(function (itm) {
			return itm.user_hash == p;
		});
		filteredArray = filteredArray;
		if (filteredArray[0].in_group == 0) {
			filteredArray[0].in_group = 1;
		} else {
			if (filteredArray[0].is_manager == 0) {
				filteredArray[0].in_group = 0;
			}
		}
		this.constructorHTML(teamList);
	}
};

var NotificationList;
var Notification = {
	init: function () {
		var selfThis = this;
		this.get();
		setInterval(function () {
			selfThis.get();
		}, 30000);
	},
	get: function () {
		var selfThis = this;
		$.ajax({
			type: "POST",
			url: "/Service.aspx/ListNotifications",
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				if (response.d != undefined) {
					NotificationList = response.d;
				}
				selfThis.constructorHTML(NotificationList);
			}
		});
	},
	constructorHTML: function (paramList) {
		var element = $('.js-notification-list');
		countNotification = 0;
		if (element[0]) {
			var htmlBlock = '';

			if (paramList == undefined || paramList.length == 0) {
				htmlBlock = '<div class="notification__item empty">Nenhuma notificação no momento.</div>';
			} else {
				paramList.map(function (e) {
					if (!e.is_viewed) {
						countNotification++;
					}
					var cssClassItem = e.is_viewed ? '' : 'active';
					var itemImage = e.post_image != '' ? '<img src="' + baseURLImagesPost + e.post_image + '" alt="Profile" />' : '';
					htmlBlock += '<div class="notification__item"> \
						<a href="#" class="notification__item--link js-notification-open ' + cssClassItem + '" data-hash="' + e.notification_hash + '" data-post="' + e.post_hash + '"> \
							<div class="notification__item--user"> \
								<img src="' + baseURLImagesUser + e.user_picture + '" alt="Profile" /></div> \
							<div class="notification__item--info"> \
								<p>' + e.notification_description + '</p> \
							</div> \
							<div class="notification__item--thumb"> \
								' + itemImage + ' \
							</div> \
						</a> \
						<a href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover essa notificação?' + '\', { confirmActionCallback: function() { Notification.deleteNotification(\'' + e.notification_hash + '\') } } );" class="notification__item--del"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#trash"></use></svg></a> \
					</div>';
				});
			}
			//console.log(htmlBlock);
			if (countNotification > 0) {
				$('.notification__ico--badges').stop().fadeIn().html(countNotification);
			} else {
				$('.notification__ico--badges').stop().fadeOut();
			}
			element.html(htmlBlock);
			centralizeModal('#modalTeamEdit');
			this.eventLinks(element);
		}
	},
	eventLinks: function (el) {
		var element = el,
			selfThis = this;
		if (!element[0]) {
			return false;
		}
		element.on('click', '.js-notification-open', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			//console.log('abrir o post ' + $(this).attr('data-hash'));
			selfThis.updateNotificationList($(this).attr('data-hash'));
			Post.getDetail($(this).attr('data-post'), $(this).attr('data-hash'));
			return false;
		});
	},
	updateNotificationList: function (p) {
		var filteredArray = NotificationList.filter(function (itm) {
			return itm.notification_hash == p;
		});
		filteredArray = filteredArray;
		if (!filteredArray[0].is_viewed) {
			filteredArray[0].is_viewed = true;
		}
		this.constructorHTML(NotificationList);
	},
	deleteNotification: function (p) {
		var selfThis = this;
		//console.log('deleteNotification ' + p);
		//setTimeout(function(){ selfThis.init(); }, 2000);
		$.ajax({
			type: "POST",
			url: "/Service.aspx/DeleteNotification",
			data: '{"notification_hash":"' + p + '"}',
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function () {
				selfThis.init();
			}
		});
	}
};

var Scroll = {
	init: function () {
		var elLoadScroll = $('.load__more');
		if (elLoadScroll[0]) {
			$(window).on("scroll", function () {
				if (elLoadScroll.isInViewport()) {
					Scroll.more();
				}
			});
		}
	},
	more: function () {
		Post.get(pageScrollCurrent);
	}
};

var PostList;
var PostDetail;
var PostImages = [];
var requestPost = null;
var Post = {
	init: function () {
		var el = $('.js-post-list');
		if (!el[0]) {
			return false
		}
		;
		this.get(pageScrollCurrent);
	},
	get: function (paramPost) {
		var selfThis = this,
			paramService = '{"page":"' + paramPost + '"}',
			paramURLtype = $('.js-post-user')[0] ? 'ListUserProfilePosts' : 'ListHome';

		if (requestPost != null) {
			return false;
		}
		requestPost = $.ajax({
			type: "POST",
			url: "/Service.aspx/" + paramURLtype,
			dataType: "json",
			data: paramService,
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				if (pageScrollCurrent == 1 && response.d.home_post.length == 0) {
					$('.load__more').stop().fadeOut();
					$('.js-post-user').html('<p>Nenhum resultado encontrado.</p>')
				}
				if (response.d != undefined && response.d.home_post.length > 0) {
					PostList = response.d;
					selfThis.constructorListHTML(PostList);
					pageScrollCurrent++;
					if (pageScrollCurrent > response.d.Totalpage) {
						$('.load__more').stop().fadeOut();
					}
				}
				setTimeout(function () {
					requestPost = null;
				});
			}, error: function () {
				setTimeout(function () {
					requestPost = null;
				});
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	getDetail: function (paramPost, paramNotification, isUpdateList) {
		var selfThis = this;
		var paramService = !paramNotification ? '{"post_hash":"' + paramPost + '", "notification_hash":""}' : '{"post_hash":"' + paramPost + '", "notification_hash":"' + paramNotification + '"}';
		$.ajax({
			type: "POST",
			url: "/Service.aspx/ListPostDetail",
			dataType: "json",
			data: paramService,
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				if (response.d != undefined) {
					PostDetail = response.d;
					selfThis.constructorHTML(PostDetail);
					if (isUpdateList) {
						Post.updatePostExistList(paramPost, response);
					}
				}
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	constructorHTML: function (e) {
		var element = $('.js-post-detail');
		if (element[0]) {
			var htmlBlock = '',
				htmlBlockImages = '',
				htmlBlockComments = '',
				htmlActionButtonsPost = '',
				hasVideo = false;

			if (e.post_image.length > 0) {
				e.post_image.map(function (i) {

					if (e.post_image[0].path_image.length > 0) {
						if (e.post_image[0].path_video != '') {
							hasVideo = true;
							htmlBlockImages = '<div class="slider__item slider--primary__item"> <div class="video-container"> \
								<video id="videoDetail_' + e.post_hash + '" preload="none" poster="' + e.post_image[0].path_image + '" class="jlplayer-video"> \
									<source src="' + e.post_image[0].path_video + '" type="video/mp4"> \
								</video> \
							</div> </div>';
						} else {
							htmlBlockImages += '<div class="slider__item slider--primary__item"> \
								<img src="' + baseURLImagesPost + i.path_image + '" alt="Banner" /> \
							</div>';
						}
					}
				});
			}
			if (e.post_comment.length > 0) {
				e.post_comment.map(function (c) {
					var htmlBlockCommentsAnswers = '';
					//var htmlActionRemoveComment = userClient.getUserKey() == 1 ? '<a class="post__comments__delete" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse comentário?' + '\', { confirmActionCallback: function() { Comment.delete(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\') } } );"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#trash"></use></svg></a>' : '';
					var htmlActionRemoveComment = userClient.getUserKey() == 1 ? '<div class="post__comments__delete"> \
						<button type="button" data-toggle="dropdown"> \
							<svg class="svg" width="26" height="5"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#dots"> \
								</use> \
							</svg> \
						</button> \
						<div class="dropdown-menu"> \
							<a class="dropdown-item" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse comentário?' + '\', { confirmActionCallback: function() { Comment.delete(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\') } } );"> \
								<svg class="svg trash"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
									</use> \
								</svg> \
								<span>Excluir</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_comment_hash + '\', \'' + hashStatusComentPublic + '\')"> \
								<svg class="svg edit"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
									</use> \
								</svg> \
								<span>Público</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_comment_hash + '\', \'' + hashStatusComentPrivate + '\')"> \
								<svg class="svg blocked"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#lock"> \
									</use> \
								</svg> \
								<span>Privado</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Comment.commentAnswers(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\')"> \
								<svg class="svg blocked"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#send"> \
									</use> \
								</svg> \
								<span>Responder</span> \
							</a> \
						</div> \
					</div>' : '';

					if (c.Answers.length > 0) {

						c.Answers.map(function (a) {

							var htmlActionRemoveCommentAnswers = userClient.getUserKey() == 1 ? '<a class="post__comments__delete" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover essa resposta?' + '\', { confirmActionCallback: function() { Comment.deleteAnswers(\'' + a.Comment_Answers_id + '\', \'' + e.post_hash + '\') } } );"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#trash"></use></svg></a>' : '';

							htmlBlockCommentsAnswers += '<li class="d-flex justify-content-start align-items-start" style="margin-top:-15px" data-comment="' + a.Comment_Answers_id + '"> \
																	<img class="post__comments__image" src="' + baseURLImagesUser + a.User_Picture + '" \
																		alt=""> \
																	<span> \
																		<div class="post__comments__item"> \
																			<span class="mr-2">\
																				<strong class="post__comments__author">' + a.User_NickName + '</strong> \
																				' + a.Comment_Description + '\
																			</span>\
																			' + htmlActionRemoveCommentAnswers + '\
																		</div> \
																	</span> \
																</li>';
						});

					}

					htmlBlockComments += '<li class="d-flex justify-content-start align-items-start" data-comment="' + c.post_comment_hash + '"> \
						<img class="post__comments__image" src="' + baseURLImagesUser + c.user_picture + '" alt=""> \
						<span> \
							<div class="post__comments__item"> \
								<span class="mr-2">\
									<strong class="post__comments__author">' + c.user_nicknane + '</strong> ' +
						'' + c.comment_description + '' +
						'</span>' +
						'' + htmlActionRemoveComment + '  \
							</div> \
							<span> \
								<span class="post__comments__time">' + c.commented_at + '</span> \
							</span> \
						</span>' + htmlBlockCommentsAnswers + ' \ </li>';

				});
			}
			if (userClient.getUserKey() == 1) {
				htmlActionButtonsPost = '<div class="dropdown post__options"> \
					<button type="button" data-toggle="dropdown"> \
						<svg class="svg" width="26" height="5"> \
							<use xlink:href="/Content/build/assets/images/svg.svg#dots"> \
							</use> \
						</svg> \
					</button> \
					<div class="dropdown-menu"> \
						<a class="dropdown-item" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse post?' + '\', { confirmActionCallback: function() { Post.delete(\'' + e.post_hash + '\') } } );"> \
							<svg class="svg trash"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
								</use> \
							</svg> \
							<span>Excluir</span> \
						</a> \
						<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_hash + '\', \'' + hashStatusPrimary + '\')"> \
							<svg class="svg edit"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
								</use> \
							</svg> \
							<span>Público</span> \
						</a> \
						<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_hash + '\', \'' + hashStatusSecondary + '\')"> \
							<svg class="svg blocked"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#lock"> \
								</use> \
							</svg> \
							<span>Privado</span> \
						</a> \
						<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_hash + '\', \'' + hashStatusTertiary + '\')"> \
							<svg class="svg trash"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#blocked"> \
								</use> \
							</svg> \
							<span>Restrito</span> \
						</a> \
					</div> \
				</div>';
			} else if (e.is_post_owner == 1) {
				htmlActionButtonsPost = '<div class="dropdown post__options"> \
					<button type="button" data-toggle="dropdown"> \
						<svg class="svg" width="26" height="5"> \
							<use xlink:href="/Content/build/assets/images/svg.svg#dots"> \
							</use> \
						</svg> \
					</button> \
					<div class="dropdown-menu"> \
						<a class="dropdown-item" href="javascript:Post.getUpdatePost(\'' + e.post_hash + '\')"> \
							<svg class="svg edit"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#edit"> \
								</use> \
							</svg> \
							<span>Editar</span> \
						</a> \
						<a class="dropdown-item" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse post?' + '\', { confirmActionCallback: function() { Post.delete(\'' + e.post_hash + '\') } } );"> \
							<svg class="svg trash"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
								</use> \
							</svg> \
							<span>Excluir</span> \
						</a> \
					</div> \
				</div>';
			}

			var htmlButtonLike = e.is_liked == 0 ? '<a href="javascript:Like.set(\'' + e.post_hash + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#like"></use></svg></a>' : '<a href="javascript:Like.set(\'' + e.post_hash + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#likeFill"></use></svg></a>';
			var textPostStatus = '';
			if (e.post_status_hash == hashStatusPrimary) {
				textPostStatus = 'Público';
			} else if (e.post_status_hash == hashStatusSecondary) {
				textPostStatus = 'Privado';
			} else if (e.post_status_hash == hashStatusTertiary) {
				textPostStatus = 'Restrito';
			}

			var path_link = e.path_link != '' ? '<a href="' + e.path_link + '" class="link-secondary" target="_blank"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#externalLink"></use></svg> Acesse o link</a>' : '';

			htmlBlock += '<div class="col-12 col-md-8 m-0 p-0"> \
					<section class="slider slider--posts js-post-slider">' + htmlBlockImages + '</section> \
				</div> \
				<div class="col-12 col-md-4 pt-3 pl-3 pr-3 bg-light position-relative"> \
					<article class="post__body"> \
						<header class="post__header d-flex justify-content-start align-items-start"> \
							<img class="post__image" src="' + baseURLImagesUser + e.user_picture + '" alt="Name"> \
							<div> \
								<h3 class="post__auhtor"><strong>' + e.user_nickname + '</strong></h3> \
								<h4 class="post__location">' + e.dealership + '</h4> \
								<ul class="post__location d-flex justify-content-start align-items-center js-post-status-header"> \
									<li>' + e.posted_at + '</li> \
									<li>•</li> \
									<li> \
										<svg class="svg" width="13" height="13"> \
											<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
											</use> \
										</svg> \
										' + textPostStatus + ' \
									</li> \
								</ul> \
							</div> \
							' + htmlActionButtonsPost + ' \
						</header> \
						<p class="post__content">' + e.post_description + '</p> \
						' + path_link + ' \
						<footer class="post__footer"> \
							<div class="post__footer__item d-flex justify-content-between align-items-center"> \
								<div class="d-flex align-items-center"><a href="javascript:void();" onmouseenter="Post.likesByPost(`${e.post_hash}`, \'tooltiptext-scroll-modal\')" class="d-flex mr-3 tooltip-post"> \
									<div class="tooltip-thumbs"> \
									</div> \
									<div class="tooltiptext">\
										<div class="tooltiptext-scroll tooltiptext-scroll-modal" data-likes="' + e.post_hash + '"></div>\
									</div>\
								</a> \
								<span class="d-flex justify-content-center align-items-center"> \
									' + htmlButtonLike + ' \
									' + e.QtdeLike + ' \
								</span></div> \
								<span class="d-flex justify-content-center align-items-center">' + e.QtdeComment + ' comentários</span> \
							</div> \
						</footer> \
						<ul class="post__comments"> ' + htmlBlockComments + ' </ul> \
						<fieldset> \
							<div class="post__comment"> \
								<img class="post__comments__image" src="' + baseURLImagesUser + userClient.getUserThumb() + '"> \
								<input type="text" class="form-control js-post-detail-comment" placeholder="Escreva um comentário... "> \
								<a href="javascript:Comment.set(\'' + e.post_hash + '\')"> \
									<svg class="svg" width="25" height="25"> \
										<use xlink:href="/Content/build/assets/images/svg.svg#send"> \
										</use> \
									</svg> \
								</button> \
							</div> \
						</fieldset> \
					</article> \
				</div>';

			element.html(htmlBlock);

			abreModal('#postDetails');

			this.eventLinks(element);
			Sliders.post();
			Post.likesByPost(`${e.post_hash}`, 'tooltiptext-scroll-modal');

			element.find(".js-post-slider").addClass("opened");

			if (hasVideo) {
				setTimeout(function () {
					setVideoPlayer();
				}, 500);
			}
		}
	},
	constructorListHTML: function (el, isDetail) {
		var element = $('.js-post-list'),
			selfThis = this,
			hasVideo = false;
		if (element[0]) {
			var htmlBlock = '';
			el.home_post.map(function (e, i) {
				var htmlBlockImages = '',
					htmlBlockComments = '',
					htmlActionButtonsPost = '';


				if (e.post_image.length > 0) {
					if (e.post_image[0].path_image.length > 0) {
						if (e.post_image[0].path_video != '') {
							hasVideo = true;
							htmlBlockImages = '<div class="video-container"> \
								<video id="video_' + e.post_hash + '" preload="none" poster="' + e.post_image[0].path_image + '" class="jlplayer-video"> \
									<source src="' + e.post_image[0].path_video + '" type="video/mp4"> \
								</video> \
							</div>';
						} else {
							htmlBlockImages = '<a href="javascript:Post.getDetail(\'' + e.post_hash + '\');" class="d-block"> \
								<img src="' + baseURLImagesPost + e.post_image[0].path_image + '" alt="Name" /> \
							</a>';
						}
					}
				}
				if (e.post_comment.length > 0) {
					e.post_comment.map(function (c) {
						var htmlBlockCommentsAnswers = '';
						//var htmlActionRemoveComment = userClient.getUserKey() == 1 ? '<a class="post__comments__delete" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse comentário?' + '\', { confirmActionCallback: function() { Comment.delete(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\') } } );"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#trash"></use></svg></a>' : '';
						var htmlActionRemoveComment = userClient.getUserKey() == 1 ? '<div class="post__comments__delete"> \
						<button type="button" data-toggle="dropdown"> \
							<svg class="svg" width="26" height="5"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#dots"> \
								</use> \
							</svg> \
						</button> \
						<div class="dropdown-menu"> \
							<a class="dropdown-item" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse comentário?' + '\', { confirmActionCallback: function() { Comment.delete(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\') } } );"> \
								<svg class="svg trash"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
									</use> \
								</svg> \
								<span>Excluir</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Comment.statusUpdate(\'' + c.post_comment_hash + '\', \'' + hashStatusComentPublic + '\')"> \
								<svg class="svg edit"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
									</use> \
								</svg> \
								<span>Público</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Comment.statusUpdate(\'' + c.post_comment_hash + '\', \'' + hashStatusComentPrivate + '\')"> \
								<svg class="svg blocked"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#lock"> \
									</use> \
								</svg> \
								<span>Privado</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Comment.commentAnswers(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\')"> \
								<svg class="svg blocked"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#send"> \
									</use> \
								</svg> \
								<span>Responder</span> \
							</a> \
						</div> \
					</div>' : '';

						if (c.Answers.length > 0) {

							console.log(c.Answers.length);

							c.Answers.map(function (a) {
								var htmlActionRemoveCommentAnswers = userClient.getUserKey() == 1 ? '<a class="post__comments__delete" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover essa resposta?' + '\', { confirmActionCallback: function() { Comment.deleteAnswers(\'' + a.Comment_Answers_id + '\', \'' + e.post_hash + '\') } } );"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#trash"></use></svg></a>' : '';

								htmlBlockCommentsAnswers += '<li class="d-flex justify-content-start align-items-start" style="margin-top:-15px" data-comment="' + a.Comment_Answers_id + '"> \
															<img class="post__comments__image" src="' + baseURLImagesUser + a.User_Picture + '" \
																alt=""> \
															<span> \
																<div class="post__comments__item">\
																	 <span class="mr-2">\
																		<strong class="post__comments__author">' + a.User_NickName + '</strong> \
																		' + a.Comment_Description + '' +
									'</span> '
									+ htmlActionRemoveCommentAnswers + ' \
																</div> \
															</span>\
														</li>';


							});
						}
						;

						htmlBlockComments += '<li class="d-flex justify-content-start align-items-start" data-comment="' + c.post_comment_hash + '"> \
							<img class="post__comments__image" src="' + baseURLImagesUser + c.user_picture + '" \
								alt=""> \
							<span> \
								<div class="post__comments__item"> \
									<span class="mr-2">\
										<strong class="post__comments__author">' + c.user_nicknane + '</strong> \
										' + c.comment_description + '' +
							'</span>' +
							'' + htmlActionRemoveComment + ' \
								</div> \
								<span> \
									<span class="post__comments__time">' + c.commented_at + '</span>\
								</span> \
							</span>' + htmlBlockCommentsAnswers + '</li>';


					});
				}
				if (userClient.getUserKey() == 1) {
					htmlActionButtonsPost = '<div class="dropdown post__options"> \
						<button type="button" data-toggle="dropdown"> \
							<svg class="svg" width="26" height="5"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#dots"> \
								</use> \
							</svg> \
						</button> \
						<div class="dropdown-menu"> \
							<a class="dropdown-item" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse post?' + '\', { confirmActionCallback: function() { Post.delete(\'' + e.post_hash + '\') } } );"> \
								<svg class="svg trash"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
									</use> \
								</svg> \
								<span>Excluir</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_hash + '\', \'' + hashStatusPrimary + '\')"> \
								<svg class="svg edit"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
									</use> \
								</svg> \
								<span>Público</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_hash + '\', \'' + hashStatusSecondary + '\')"> \
								<svg class="svg blocked"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#lock"> \
									</use> \
								</svg> \
								<span>Privado</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_hash + '\', \'' + hashStatusTertiary + '\')"> \
								<svg class="svg trash"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#blocked"> \
									</use> \
								</svg> \
								<span>Restrito</span> \
							</a> \
						</div> \
					</div>';
				} else if (e.is_post_owner == 1) {
					htmlActionButtonsPost = '<div class="dropdown post__options"> \
						<button type="button" data-toggle="dropdown"> \
							<svg class="svg" width="26" height="5"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#dots"> \
								</use> \
							</svg> \
						</button> \
						<div class="dropdown-menu"> \
							<a class="dropdown-item" href="javascript:Post.getUpdatePost(\'' + e.post_hash + '\')"> \
								<svg class="svg edit"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#edit"> \
									</use> \
								</svg> \
								<span>Editar</span> \
							</a> \
							<a class="dropdown-item" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse post?' + '\', { confirmActionCallback: function() { Post.delete(\'' + e.post_hash + '\') } } );"> \
								<svg class="svg trash"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
									</use> \
								</svg> \
								<span>Excluir</span> \
							</a> \
						</div> \
					</div>';
				}

				var htmlButtonLike = e.is_liked == 0 ? '<a href="javascript:Like.set(\'' + e.post_hash + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#like"></use></svg></a>' : '<a href="javascript:Like.set(\'' + e.post_hash + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#likeFill"></use></svg></a>';
				var htmlButtonLikeLarger = e.is_liked == 0 ? '<svg class="svg"> <use xlink:href="/Content/build/assets/images/svg.svg#like"></use></svg> Curtir' : '<svg class="svg"> <use xlink:href="/Content/build/assets/images/svg.svg#likeFill"></use></svg> Curtir';
				var textPostStatus = '';
				if (e.post_status_hash == hashStatusPrimary) {
					textPostStatus = 'Público';
				} else if (e.post_status_hash == hashStatusSecondary) {
					textPostStatus = 'Privado';
				} else if (e.post_status_hash == hashStatusTertiary) {
					textPostStatus = 'Restrito';
				}
				var descriptionList = e.post_description.substr(0, 300) + '...';

				var path_link = e.path_link != '' ? '<a href="' + e.path_link + '" class="link-secondary" target="_blank"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#externalLink"></use></svg> Acesse o link</a>' : '';

				htmlBlock += '<article class="post__body pt-3 mb-3"> \
					<header class="post__header d-flex justify-content-start align-items-start" data-hash="' + e.post_hash + '"> \
						<img class="post__image" src="' + baseURLImagesUser + e.user_picture + '" alt="Name"> \
						<div> \
							<h3 class="post__auhtor"><strong>' + e.user_nickname + '</strong></h3> \
							<h4 class="post__location">' + e.dealership + '</h4> \
							<ul class="post__location d-flex justify-content-start align-items-center js-post-status-header"> \
								<li>' + e.posted_at + '</li> \
								<li>•</li> \
								<li> \
									' + textPostStatus + ' \
								</li> \
							</ul> \
						</div> \
						' + htmlActionButtonsPost + ' \
					</header> \
					<p class="post__content"> ' + descriptionList + ' </p> \
					' + path_link + ' \
					<div class="post__content"> \
						<a href="javascript:Post.getDetail(\'' + e.post_hash + '\');" \
							class="post__content__more post__content__more--fixed">...Veja \
							mais</a> \
							' + htmlBlockImages + ' \
					</div> \
					<footer class="post__footer"> \
						<div \
							class="post__footer__item d-flex justify-content-between align-items-center">\
							 <div class="d-flex align-items-center"><a href="javascript:void();" class="d-flex mr-3 tooltip-post"> \
								<div class="tooltip-thumbs"></div> \
								<div class="tooltiptext">\
									<div class="tooltiptext-scroll tooltiptext-scroll-home" data-likes="' + e.post_hash + '"></div>\
								</div>\
							</a> \
							<span class="d-flex justify-content-center align-items-center"> \
								' + htmlButtonLike + ' \
								' + e.QtdeLike + ' \
							</span></div> \
							<span class="d-flex justify-content-center align-items-center">' + e.QtdeComment + ' \
								comentários</span> \
						</div> \
						<div \
							class="post__footer__item post__footer__item--actions d-flex justify-content-between align-items-center"> \
							<a href="javascript:Like.set(\'' + e.post_hash + '\');" class="d-flex justify-content-center align-items-center js-post-like-larger"> \
								' + htmlButtonLikeLarger + ' \
							</a> \
							<span class="divider"></span> \
							<a href="javascript:Post.getDetail(\'' + e.post_hash + '\');" class="d-flex justify-content-center align-items-center"> \
								<svg class="svg"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#comment"> \
									</use> \
								</svg> \
								Comentar \
							</a> \
						</div> \
					</footer> \
					<ul class="post__comments"> \
						' + htmlBlockComments + ' \
				   </ul> \
					<a href="javascript:Post.getDetail(\'' + e.post_hash + '\');" class="post__content__more post__content__more--comments">Ver mais \
						comentários</a> \
				</article><hr />';
				Post.likesByPost(`${e.post_hash}`, 'tooltiptext-scroll-home');
			});
			element.append(htmlBlock);
			this.eventLinks(element);

			if (hasVideo) {
				setVideoPlayer();
			}

		}
	},
	likesByPost: function (s, c) {
		// return;
		var htmlPhotos = '';
		var htmlNames = '';
		$.ajax({
			type: "POST",
			url: "/Service.aspx/ListPostLike",
			dataType: "json",
			data: '{"post_hash":"' + s + '"}',
			contentType: "application/json; charset=utf-8",
			success: function (d) {
				if (d.d === null || d.d === undefined) {
					return;
				}
				d.d?.ListLikes.map(function (x, i) {
					if (i <= 2) {
						htmlPhotos += '<img class="post__footer_person-img ' + (i > 1 ? 'dislocated' : '') + '" src="' + x.path_image + '" alt="img" />';
					}
					htmlNames += x.Name.split(' ')[0] + '<br/>'
				});
				console.log('datalikes');
				$('.' + c + '[data-likes="' + s + '"]').html(d.d.ListLikes.length === 0 ? '0 curtida' : htmlNames);
				$('.' + c + '[data-likes="' + s + '"]').closest('.tooltip-post').find('.tooltip-thumbs').html(htmlPhotos);
			}
		});
	},
	eventLinks: function (e) {
		//console.log('events post');
		//console.log(e);
	},
	statusUpdate: function (p, h) {
		var selfThis = this;
		$.ajax({
			type: "POST",
			url: "/Service.aspx/UpdatePostStatus",
			dataType: "json",
			data: '{"post_hash":"' + p + '", "status_hash":"' + h + '"}',
			contentType: "application/json; charset=utf-8",
			success: function () {
				if ($('.js-post-list')[0] && $('#postDetails').is(':hidden')) {
					//console.log('aqui 0');
					if (h == hashStatusTertiary) {
						$('.js-post-list').html('');
						pageScrollCurrent = 1;
						selfThis.get(pageScrollCurrent);
					} else {
						var PostListHTML = $('.js-post-list'),
							PostItemHTML = PostListHTML.find('.post__header[data-hash="' + p + '"]');
						if (PostItemHTML[0]) {
							var textPostStatus = '';
							if (h == hashStatusPrimary) {
								textPostStatus = '<svg class="svg" width="13" height="13"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
									</use> \
								</svg> Público';
							} else if (h == hashStatusSecondary) {
								textPostStatus = '<svg class="svg" width="13" height="13"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
									</use> \
								</svg> Privado';
							} else if (h == hashStatusTertiary) {
								textPostStatus = '<svg class="svg" width="13" height="13"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
									</use> \
								</svg> Restrito';
							}
							PostItemHTML.find('.js-post-status-header').find('li:eq(2)').html(textPostStatus);
						}
					}
				} else if ($('#postDetails').is(':visible')) {
					if (h == hashStatusTertiary) {
						fechaModal('#postDetails');
					} else {
						Post.getDetail(p, '', true);
					}
				}
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	updatePostExistList: function (e, resp) {
		var PostListHTML = $('.js-post-list'),
			PostItemHTML = PostListHTML.find('.post__header[data-hash="' + e + '"]'),
			htmlBlockComments = '';

		if (PostItemHTML[0]) {
			var htmlButtonLike = resp.d.is_liked == 0 ? '<a href="javascript:Like.set(\'' + e + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#like"></use></svg></a>' : '<a href="javascript:Like.set(\'' + e + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#likeFill"></use></svg></a>';
			var htmlButtonLikeLarger = resp.d.is_liked == 0 ? '<svg class="svg"> <use xlink:href="/Content/build/assets/images/svg.svg#like"></use></svg> Curtir' : '<svg class="svg"> <use xlink:href="/Content/build/assets/images/svg.svg#likeFill"></use></svg> Curtir';

			resp.d.post_comment.map(function (c, i) {
				if (i <= 2) {
					//var htmlActionRemoveComment = userClient.getUserKey() == 1 ? '<a class="post__comments__delete" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse comentário?' + '\', { confirmActionCallback: function() { Comment.delete(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\') } } );"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#trash"></use></svg></a>' : '';
					var htmlActionRemoveComment = userClient.getUserKey() == 1 ? '<div class="post__comments__delete"> \
						<button type="button" data-toggle="dropdown"> \
							<svg class="svg" width="26" height="5"> \
								<use xlink:href="/Content/build/assets/images/svg.svg#dots"> \
								</use> \
							</svg> \
						</button> \
						<div class="dropdown-menu"> \
							<a class="dropdown-item" href="javascript:abreModal(\'' + '#modalConfirm' + '\', \'' + 'Tem certeza que deseja remover esse comentário?' + '\', { confirmActionCallback: function() { Comment.delete(\'' + c.post_comment_hash + '\', \'' + e.post_hash + '\') } } );"> \
								<svg class="svg trash"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
									</use> \
								</svg> \
								<span>Excluir</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_comment_hash + '\', \'' + hashStatusPrimary + '\')"> \
								<svg class="svg"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
									</use> \
								</svg> \
								<span>Público</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_comment_hash + '\', \'' + hashStatusSecondary + '\')"> \
								<svg class="svg blocked"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#lock"> \
									</use> \
								</svg> \
								<span>Privado</span> \
							</a> \
							<a class="dropdown-item" href="javascript:Post.statusUpdate(\'' + e.post_comment_hash + '\', \'' + hashStatusSecondary + '\')"> \
								<svg class="svg blocked"> \
									<use xlink:href="/Content/build/assets/images/svg.svg#blocked"> \
									</use> \
								</svg> \
								<span>Responder</span> \
							</a> \
						</div> \
					</div>' : '';
					htmlBlockComments += '<li class="d-flex justify-content-start align-items-start" data-comment="' + c.post_comment_hash + '"> \
						<img class="post__comments__image" src="' + baseURLImagesUser + c.user_picture + '" \
							alt=""> \
						<span> \
							<div class="post__comments__item"> \
								<span class="mr-2">\
									<strong class="post__comments__author">' + c.user_nicknane + '</strong> \
									' + c.comment_description + '' +
						'</span>' +
						'' + htmlActionRemoveComment + ' \
							</div> \
							<span> \
								<span class="post__comments__time">' + c.commented_at + '</span> \
							</span> \
						</span>\
					</li>';


					if (c.Answers.length > 0) {

						c.Answers.map(function (a) {

							console.log('answers');
							console.log(a);
							console.log(a.Comment_answers_id);

							htmlBlockCommentsAnswers += '<li class="d-flex justify-content-start align-items-start" style="margin-top:-15px" data-comment="' + a.Comment_Answers_id + '"> \
															<img class="post__comments__image" src="' + baseURLImagesUser + a.User_Picture + '" \
																alt=""> \
															<span> \
																<div class="post__comments__item"> \
																	<span>\
																		<strong class="post__comments__author">' + a.User_NickName + '</strong> \
																		' + a.Comment_Description + '\
																	</span> \
																</div> \
															</span>\
														</li>';
						});
					}
					;
				}
			});
			var textPostStatus = '';
			if (resp.d.post_status_hash == hashStatusPrimary) {
				textPostStatus = '<svg class="svg" width="13" height="13"> \
					<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
					</use> \
				</svg> Público';
			} else if (resp.d.post_status_hash == hashStatusSecondary) {
				textPostStatus = '<svg class="svg" width="13" height="13"> \
					<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
					</use> \
				</svg> Privado';
			} else if (resp.d.post_status_hash == hashStatusTertiary) {
				textPostStatus = '<svg class="svg" width="13" height="13"> \
					<use xlink:href="/Content/build/assets/images/svg.svg#globe"> \
					</use> \
				</svg> Restrito';
			}
			PostItemHTML.find('.js-post-status-header').find('li:eq(2)').html(textPostStatus);
			PostItemHTML.parent().find('.js-post-like-larger').html(htmlButtonLikeLarger);
			PostItemHTML.parent().find('.post__footer').find('span:eq(0)').html(htmlButtonLike + ' ' + resp.d.QtdeLike);
			PostItemHTML.parent().find('.post__footer').find('span:eq(1)').html(resp.d.QtdeComment + ' comentários');
			PostItemHTML.parent().find('.post__comments').html(htmlBlockComments);
			PostItemHTML.parent().find('.post__comments').html(htmlBlockCommentsAnswers);
		}
	},
	postAddClear: function () {
		$('.js-post-description').val('').trigger('keyup');
		;
		PostImages = [];
		$('.js-post-add-hash').val('');
		$('.js-post-add-gallery').html('');
	},
	setImage: function () {
		var elementFile = $('.js-post-file'),
			selfThis = this;
		if (elementFile[0]) {
			if (!elementFile[0].files[0]) {
				abreModal('#modalPadrao', 'Selecione uma imagem para adicionar ao post.');
				return false;
			}
			selfThis.postImageAdd();
		}
	},
	postImageAdd: function () {
		var selfThis = this;
		if (PostImages.length > 2) {
			abreModal('#modalPadrao', 'São permitidas apenas 3 imagens por post.');
			return false;
		}
		getBase64($('.js-post-file')[0].files[0]).then(function (data) {
			//var filePost = data.replace('data:image/jpeg;base64,', '');
			var filePost = data.split(',');
			$.ajax({
				type: "POST",
				url: "/Service.aspx/UploadImage",
				dataType: "json",
				data: '{"model": {"type":"Post", "base64": "' + filePost[1] + '"}}',
				contentType: "application/json; charset=utf-8",
				success: function (response) {
					PostImages.push({ 'path_image': response.d });
					selfThis.postImageContructorHTML();
					$('.js-post-file').val('');
				}, error: function () {
					Alert.init('danger', 'Ocorreu um erro.');
				}
			});

		});


	},
	postImageContructorHTML: function () {
		var htmlBlock = '';
		PostImages.map(function (el, i) {
			htmlBlock += '<li> \
				<img class="post__gallery--image" src="' + baseURLImagesPost + el.path_image + '" alt="Name" /> \
				<a href="javascript:Post.postRemoveImageUpload(\'' + i + '\')" class="post__gallery--link"> \
					<svg class="svg"> \
						<use xlink:href="/Content/build/assets/images/svg.svg#trash"> \
						</use> \
					</svg> \
				</a> \
			</li>';
		});
		$('.js-post-add-gallery').html(htmlBlock);
	},
	postRemoveImageUpload: function (i) {
		PostImages.splice(i, 1);
		this.postImageContructorHTML();
	},
	save: function () {
		var selfThis = this;
		var postNewText = replaceAll($('.js-post-description').val(), '"', "'"),
			urlTypeAction = $('.js-post-add-hash').val() == '' ? "/Service.aspx/InsertPost" : "/Service.aspx/UpdatePost",
			paramTypeAction = $('.js-post-add-hash').val() == '' ? '{"post_images": ' + JSON.stringify(PostImages) + ', "post_description": "' + postNewText + '"}' : '{"post_images": ' + JSON.stringify(PostImages) + ', "post_description": "' + postNewText + '", "post_hash":"' + $('.js-post-add-hash').val() + '"}';
		if (postNewText == '') {
			abreModal('#modalPadrao', 'Escreva o que está pensando...');
			return false;
		}
		$.ajax({
			type: "POST",
			url: urlTypeAction,
			dataType: "json",
			data: paramTypeAction,
			contentType: "application/json; charset=utf-8",
			success: function () {
				if ($('#postDetails').is(':visible')) {
					Post.getDetail($('.js-post-add-hash').val(), ' ');
				}

				$('.js-post-list').html('');
				pageScrollCurrent = 1;
				selfThis.get(pageScrollCurrent);

				var msgSave = $('.js-post-add-hash').val() == '' ? 'Post inserido com sucesso!' : 'Post atualizado com sucesso!';
				Alert.init('success', msgSave);

				fechaModal('#modalPostSend');
				Post.postAddClear();
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	getUpdatePost: function (p) {
		$.ajax({
			type: "POST",
			url: "/Service.aspx/ListPostDetail",
			dataType: "json",
			data: '{"post_hash":"' + p + '", "notification_hash":""}',
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				if (response.d != undefined) {
					$('.js-post-description').val(response.d.post_description).trigger('keyup');
					response.d.post_image.map(function (i) {
						PostImages.push({ 'path_image': i.path_image });
					});
					Post.postImageContructorHTML();
					$('.js-post-add-hash').val(p);
					abreModal('#modalPostSend');
				}
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	delete: function (p) {
		var selfThis = this;
		$.ajax({
			type: "POST",
			url: "/Service.aspx/DeletePost",
			dataType: "json",
			data: '{"post_hash":"' + p + '"}',
			contentType: "application/json; charset=utf-8",
			success: function (response) {
				$('.js-post-list').html('');
				pageScrollCurrent = 1;
				selfThis.get(pageScrollCurrent);
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	}
};

var Comment = {
	set: function (p) {
		var commentText = replaceAll($('.js-post-detail-comment').val(), '"', "'");
		console.log('commentText');
		console.log(commentText);
		if (commentText == '') {
			abreModal('#modalPadrao', 'Escreva um comentário para continuar.');
			return false;
		}
		$.ajax({
			type: "POST",
			url: "/Service.aspx/InsertComment",
			dataType: "json",
			data: '{"post_hash":"' + p + '", "comment_description": "' + commentText + '"}',
			contentType: "application/json; charset=utf-8",
			success: function () {
				Post.getDetail(p, ' ', true);
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	delete: function (h, p) {
		$.ajax({
			type: "POST",
			url: "/Service.aspx/DeleteComment",
			dataType: "json",
			data: '{"comment_hash":"' + h + '"}',
			contentType: "application/json; charset=utf-8",
			success: function () {
				//console.log('comment delete status ');
				//console.log($('#postDetails').is(':visible'));
				if ($('#postDetails').is(':visible')) {
					Post.getDetail(p, '', true);
				} else if (!$('#postDetails').is(':visible')) {
					$('.js-post-list').html('');
					pageScrollCurrent = 1;
					Post.get(pageScrollCurrent);
				}
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	statusUpdate: function (p, h) {
		$.ajax({
			type: "POST",
			url: "/Service.aspx/UpdateCommentStatus",
			dataType: "json",
			data: '{"comment_hash":"' + p + '", "status_hash":"' + h + '"}',
			contentType: "application/json; charset=utf-8",
			success: function () {
				abreModal('#modalPadrao', 'Status atualizado com sucesso.');
				return false;
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	commentAnswers: function (p, h) {

		console.log('commentAnswers');
		console.log(h);

		this.constructorAnswers(p, h);
	},
	constructorAnswers: function (e, h) {
		var element = $('.header-comment');
		console.log(e);
		$('.comment-hash').val(e);
		$('.post-hash').val(h)

		if (element[0]) {
			var htmlBlock = '';
			htmlBlock += '<img class="post__comments__image" src="' + userClient.getUserThumb() + '"><div class="pt-2"><h3 class="post__auhtor"><a href="#">' + userClient.getUserName() + '</a></h3>\</div>\'';
			element.html(htmlBlock);

			abreModal('#commentAnswers');
		}

	},

	saveAnswers: function (e) {
		console.log('entrou save');
		console.log($('.comment-hash').val());

		const p = $('.post-hash').val();

		var commentText = replaceAll($('.js-comment-answers-input').val(), '"', "'");
		if (commentText == '') {
			abreModal('#modalPadrao', 'Escreva uma resposta para continuar.');
			return false;
		} else {
			$.ajax({
				type: "POST",
				url: "/Service.aspx/InsertCommentAnswers",
				dataType: "json",
				data: '{"comment_hash":"' + $('.comment-hash').val() + '", "comment_description": "' + commentText + '"}',
				contentType: "application/json; charset=utf-8",
				success: function () {
					$('.comment-hash').val('');
					$('.comment-hash').val('')

					if ($('#postDetails').is(':visible')) {
						Post.getDetail(p, '', true);
					} else if (!$('#postDetails').is(':visible')) {
						$('.js-post-list').html('');
						pageScrollCurrent = 1;
						Post.get(pageScrollCurrent);
					}

					fechaModal('#commentAnswers');

				}, error: function () {
					Alert.init('danger', 'Ocorreu um erro.');
				}
			});
		}
	},

	deleteAnswers: function (e, p) {
		console.log(e);

		$.ajax({
			type: "POST",
			url: "/Service.aspx/DeleteCommentAnswers",
			dataType: "json",
			data: '{"post_comment_id":"' + e + '"}',
			contentType: "application/json; charset=utf-8",
			success: function () {
				//console.log('comment delete status ');
				//console.log($('#postDetails').is(':visible'));
				if ($('#postDetails').is(':visible')) {
					Post.getDetail(p, '', true);
				} else if (!$('#postDetails').is(':visible')) {
					$('.js-post-list').html('');
					pageScrollCurrent = 1;
					Post.get(pageScrollCurrent);
				}
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});


	}

};

var Like = {
	set: function (p) {
		var selfThis = this;
		$.ajax({
			type: "POST",
			url: "/Service.aspx/Like",
			dataType: "json",
			data: '{"post_hash":"' + p + '"}',
			contentType: "application/json; charset=utf-8",
			success: function () {
				if ($('.js-post-list')[0] && $('#postDetails').is(':visible')) {
					//console.log('curtiu aberto');
					Post.getDetail(p, ' ', true);
				} else if ($('.js-post-list')[0] && $('#postDetails').is(':hidden')) {
					//console.log('curtiu fechado');
					selfThis.statusUpdateListHtml(p);
				}
			}, error: function () {
				Alert.init('danger', 'Ocorreu um erro.');
			}
		});
	},
	statusUpdateListHtml: function (e) {
		var PostListHTML = $('.js-post-list'),
			PostItemHTML = PostListHTML.find('.post__header[data-hash="' + e + '"]'),
			htmlBlockComments = '';

		var stateCurrent = PostItemHTML.parent().find('.post__footer').find('span:eq(0)').find('svg')[0].innerHTML.indexOf('likeFill') >= 0 ? true : false;
		var stateCurrentQtd = PostItemHTML.parent().find('.post__footer').find('span:eq(0)').text();
		stateCurrentQtd = stateCurrent ? parseInt(stateCurrentQtd) - 1 : parseInt(stateCurrentQtd) + 1;
		var htmlButtonLike = stateCurrent ? '<a href="javascript:Like.set(\'' + e + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#like"></use></svg></a>' : '<a href="javascript:Like.set(\'' + e + '\');" class="liked"><svg class="svg"><use xlink:href="/Content/build/assets/images/svg.svg#likeFill"></use></svg></a>';
		var htmlButtonLikeLarger = stateCurrent ? '<svg class="svg"> <use xlink:href="/Content/build/assets/images/svg.svg#like"></use></svg> Curtir' : '<svg class="svg"> <use xlink:href="/Content/build/assets/images/svg.svg#likeFill"></use></svg> Curtir';
		PostItemHTML.parent().find('.js-post-like-larger').html(htmlButtonLikeLarger);
		PostItemHTML.parent().find('.post__footer').find('span:eq(0)').html(htmlButtonLike + ' ' + stateCurrentQtd);
	}
};

var userClient = {
	init: function () {
		this.getModalUserInfo();
		this.changeThumb();
	},
	getCookie: function (n) {
		/*var a = document.cookie.match(';\\s*'+n+'=([^;]+)');
		return a ? a[1] : '';*/
	},
	getUserName: function () {
		/*var h = this.getCookie('UserLogin').split('&');
		h = h[2].split('=')[1];
		return h;*/
		return $('.js-header-user-name').val();
	},
	getUserThumb: function () {
		/*var h = this.getCookie('UserLogin').split('&');
		h = h[1].split('=')[1];
		return h;*/
		return $('.js-header-user-picture').val();
	},
	getUserDealerShip: function () {
		/*var h = this.getCookie('UserLogin').split('&');
		h = h[3].split('=')[1];
		return h;*/
		return $('.js-header-user-dealership').val();
	},
	getUserKey: function () {
		/*var h = this.getCookie('UserLogin').split('&');
		h = h[4].split('=')[1];
		return h;*/
		return $('.js-header-user-admin').val();
	},
	getModalUserInfo: function () {
		var userThumbComments = $('#modalPostSend');
		if (!$('.login__image')[0]) {
			$('.js-post-timeline-image').attr('src', baseURLImagesUser + userClient.getUserThumb());
			userThumbComments.find('.post__header').find('.post__image').attr('src', baseURLImagesUser + userClient.getUserThumb());
			userThumbComments.find('.post__header').find('.post__auhtor').html('<strong>' + userClient.getUserName() + '</strong>');
			userThumbComments.find('.post__header').find('.post__location:eq(0)').html(userClient.getUserDealerShip());
		}
	},
	changeThumb: function () {
		var elBtn = $('.js-user-change-thumb');
		if (elBtn[0]) {
			elBtn.on('click', function () {
				abreModal('#modalChangeThumb');
				setTimeout(function () {
					Step.sliderThumb();
					centralizeModal('#modalChangeThumb');
				});
				return false;
			});
		}
	}
};

$.fn.isInViewport = function () {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height() + ($(window).height() / 2);

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

function getBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});
}


function setVideoPlayer() {
	var totalJLPlayer = $('.jlplayer-video');
	if (!totalJLPlayer[0]) {
		return false;
	}

	totalJLPlayer.each(function (i, e) {
		//console.log('i ' + i + ' ** ' + $(this).attr('id') + ' ** ' + !$(this).hasClass('jlplayer-cursor-show'));
		if (!$(this).hasClass('jlplayer-cursor-show')) {
			new jlPlayer($(this).attr('id'));
		}
	})
	/*totalJLPlayer = document.getElementsByClassName('jlplayer-video').length;
	if (totalJLPlayer > 0) {
		for (var i = 0; i < totalJLPlayer; i++) {
			idElement = 'jlplayer-' + Math.floor(Math.random() * 100000000);
			document.getElementsByClassName('jlplayer-video')[i].id = idElement;
			new jlPlayer(idElement);
		}
	}*/
}


var totalJLPlayer, idElement;

// Criar um novo player de vídeo
function jlPlayer(jlPlayerID) {

	// Elementos do player
	var videoTarget, jlPlayerElem, jlPlayerVideo, jlPlayerLegends, jlPlayerLoader, jlPlayerControls, volTarget,
		rangeVol, sliderVol, sliderDrag, rangeSeeker, progressBuffer, progressVideo, currentTimeTooltip, trackCaption,
		activeCaption, cuesTrack, cuesText, activityMouseFull, activityMouseTime, systemTime, isTouch,
		elementFullScreen, played;

	// Ações da barra de controles
	var jlPlayerBtnPlay, jlPlayerProgress, jlPlayerTotalTime, jlPlayerBtnVol, jlPlayerSliderVol, jlPlayerBtnCC,
		jlPlayerBtnScreen, jlPlayerBtnPlayCenter;

	// Contents
	var svgIcos, icoVol, jlPlayerContent;

	isTouch = ('ontouchstart' in document.documentElement === true);
	sliderDrag = false;
	cuesText = '';
	activeCaption = 'disabled';
	activityMouseFull = false;
	played = false;

	// Icones em SVG dos botões
	svgIcos = {
		play: '<svg viewBox="0 0 12 18"><path d="M13.6,8.1L1.9,0.2C1.1-0.3,0,0.2,0,1.1v15.7c0,0.9,1.1,1.5,1.9,0.9l11.7-7.9C14.1,9.4,14.1,8.6,13.6,8.1L13.6,8.1z"/></svg><span class="jlplayer-tooltip">Iniciar</span>',
		pause: '<svg viewBox="0 0 18 18"><path d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM12 1c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z"/></svg><span class="jlplayer-tooltip">Pausar</span>',
		restart: '<svg viewBox="0 0 18 18"><path d="M9.7 1.2l.7 6.4 2.1-2.1c1.9 1.9 1.9 5.1 0 7-.9 1-2.2 1.5-3.5 1.5-1.3 0-2.6-.5-3.5-1.5-1.9-1.9-1.9-5.1 0-7 .6-.6 1.4-1.1 2.3-1.3l-.6-1.9C6 2.6 4.9 3.2 4 4.1 1.3 6.8 1.3 11.2 4 14c1.3 1.3 3.1 2 4.9 2 1.9 0 3.6-.7 4.9-2 2.7-2.7 2.7-7.1 0-9.9L16 1.9l-6.3-.7z"/></svg><span class="jlplayer-tooltip">Reiniciar</span>',
		playc: '<svg viewBox="0 0 12 18"><path d="M13.6,8.1L1.9,0.2C1.1-0.3,0,0.2,0,1.1v15.7c0,0.9,1.1,1.5,1.9,0.9l11.7-7.9C14.1,9.4,14.1,8.6,13.6,8.1L13.6,8.1z"/></svg>',
		pausec: '<svg viewBox="0 0 18 18"><path d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM12 1c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z"/></svg>',
		volhigh: '<svg viewBox="0 0 18 18"><path d="M15.6 3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4C15.4 5.9 16 7.4 16 9c0 1.6-.6 3.1-1.8 4.3-.4.4-.4 1 0 1.4.2.2.5.3.7.3.3 0 .5-.1.7-.3C17.1 13.2 18 11.2 18 9s-.9-4.2-2.4-5.7z"></path><path d="M11.282 5.282a.909.909 0 0 0 0 1.316c.735.735.995 1.458.995 2.402 0 .936-.425 1.917-.995 2.487a.909.909 0 0 0 0 1.316c.145.145.636.262 1.018.156a.725.725 0 0 0 .298-.156C13.773 11.733 14.13 10.16 14.13 9c0-.17-.002-.34-.011-.51-.053-.992-.319-2.005-1.522-3.208a.909.909 0 0 0-1.316 0zM3.786 6.008H.714C.286 6.008 0 6.31 0 6.76v4.512c0 .452.286.752.714.752h3.072l4.071 3.858c.5.3 1.143 0 1.143-.602V2.752c0-.601-.643-.977-1.143-.601L3.786 6.008z"></path></svg><span class="jlplayer-tooltip">Desativar</span>',
		vollow: '<svg viewBox="0 0 18 18"></path><path d="M11.282 5.282a.909.909 0 0 0 0 1.316c.735.735.995 1.458.995 2.402 0 .936-.425 1.917-.995 2.487a.909.909 0 0 0 0 1.316c.145.145.636.262 1.018.156a.725.725 0 0 0 .298-.156C13.773 11.733 14.13 10.16 14.13 9c0-.17-.002-.34-.011-.51-.053-.992-.319-2.005-1.522-3.208a.909.909 0 0 0-1.316 0zM3.786 6.008H.714C.286 6.008 0 6.31 0 6.76v4.512c0 .452.286.752.714.752h3.072l4.071 3.858c.5.3 1.143 0 1.143-.602V2.752c0-.601-.643-.977-1.143-.601L3.786 6.008z"></path></svg><span class="jlplayer-tooltip">Desativar</span>',
		volmute: '<svg viewBox="0 0 18 18"><path d="M12.4 12.5l2.1-2.1 2.1 2.1 1.4-1.4L15.9 9 18 6.9l-1.4-1.4-2.1 2.1-2.1-2.1L11 6.9 13.1 9 11 11.1zM3.786 6.008H.714C.286 6.008 0 6.31 0 6.76v4.512c0 .452.286.752.714.752h3.072l4.071 3.858c.5.3 1.143 0 1.143-.602V2.752c0-.601-.643-.977-1.143-.601L3.786 6.008z"/></svg><span class="jlplayer-tooltip">Ativar</span>',
		cc: '<svg viewBox="0 0 18 18"><path d="M1 1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h4.6l2.7 2.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3l2.7-2.7H17c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1H1zm4.52 10.15c1.99 0 3.01-1.32 3.28-2.41l-1.29-.39c-.19.66-.78 1.45-1.99 1.45-1.14 0-2.2-.83-2.2-2.34 0-1.61 1.12-2.37 2.18-2.37 1.23 0 1.78.75 1.95 1.43l1.3-.41C8.47 4.96 7.46 3.76 5.5 3.76c-1.9 0-3.61 1.44-3.61 3.7 0 2.26 1.65 3.69 3.63 3.69zm7.57 0c1.99 0 3.01-1.32 3.28-2.41l-1.29-.39c-.19.66-.78 1.45-1.99 1.45-1.14 0-2.2-.83-2.2-2.34 0-1.61 1.12-2.37 2.18-2.37 1.23 0 1.78.75 1.95 1.43l1.3-.41c-.28-1.15-1.29-2.35-3.25-2.35-1.9 0-3.61 1.44-3.61 3.7 0 2.26 1.65 3.69 3.63 3.69z" fill-rule="evenodd"/></svg><span class="jlplayer-tooltip">Legenda</span>',
		fullscreen: '<svg viewBox="0 0 18 18"><path d="M10 3h3.6l-4 4L11 8.4l4-4V8h2V1h-7zM7 9.6l-4 4V10H1v7h7v-2H4.4l4-4z"/></svg><span class="jlplayer-tooltip">Tela Cheia</span>',
		restore: '<svg viewBox="0 0 18 18"><path d="M1 12h3.6l-4 4L2 17.4l4-4V17h2v-7H1zM16 .6l-4 4V1h-2v7h7V6h-3.6l4-4z"/></svg><span class="jlplayer-tooltip">Restaurar</span>'
	};

	jlPlayerContent = '<div class="jlplayer-loader"><div class="jlplayer-loader-box"><div class="jlplayer-gif"><div class="jlplayer-spinner"><div class="jlplayer-bounce1"></div><div class="jlplayer-bounce2"></div><div class="jlplayer-bounce3"></div></div></div></div></div><a href="javascript:void()" class="jlplayer-play-center"><svg viewBox="0 0 18 18"></svg></a><div class="jlplayer-legends"><span></span></div><div class="jlplayer-controls jlplayer-controls-show"><a href="javascript:void()" class="jlplayer-play"><svg viewBox="0 0 18 18"></svg><span class="jlplayer-tooltip">Iniciar</span></a><div class="jlplayer-presentation"><input class="jlplayer-rangeprog" type="range" min="0" max="100" step="0.1" value="0"><div class="jlplayer-progress"><span class="jlplayer-pbuffer"></span><span class="jlplayer-pplayed"></span></div><span class="jlplayer-tooltip">00:00</span></div><span class="jlplayer-time">00:00</span><a href="javascript:void()" class="jlplayer-vol"><svg viewBox="0 0 18 18"></svg><span class="jlplayer-tooltip">Desativar</span></a><div class="jlplayer-volume"><input class="jlplayer-rangevol" type="range" min="0" max="1" value="1" step="0.01"><div class="jlplayer-progress"><span class="jlplayer-setvolume" style="width: 100%;"></span></div></div><a href="javascript:void()" class="jlplayer-captions disabled"><svg viewBox="0 0 18 18"></svg><span class="jlplayer-tooltip">Legenda</span></a><a href="javascript:void()" class="jlplayer-screen"><svg viewBox="0 0 18 18"></svg><span class="jlplayer-tooltip">Tela Cheia</span></a></div>';

	// Cria os elementos do player
	function construct() {

		// Cria div container do player
		videoTarget = get(document, jlPlayerID);
		videoTarget.insertAdjacentHTML('afterend', '<div id="' + jlPlayerID + '"></div>');
		document.getElementById(jlPlayerID).remove();
		jlPlayerElem = get(document, jlPlayerID);
		videoTarget.removeAttribute('id');
		videoTarget.removeAttribute('class');
		jlPlayerElem.appendChild(videoTarget);
		jlPlayerElem.setAttribute('class', 'jlplayer-video jlplayer-cursor-show jlplayer-fullscreen-off');
		jlPlayerElem.innerHTML += jlPlayerContent;

		/**
		 * Elementos do player
		 */

		// Elemento vídeo do player
		jlPlayerVideo = get(jlPlayerElem, 'video', 'tag');
		// Loader
		jlPlayerLoader = get(jlPlayerElem, 'jlplayer-loader', 'class');

		// Play Center
		jlPlayerBtnPlayCenter = get(jlPlayerElem, 'jlplayer-play-center', 'class');
		jlPlayerBtnPlayCenter.innerHTML = svgIcos.playc;

		// Lengenda
		jlPlayerLegends = get(jlPlayerElem, 'jlplayer-legends', 'class');

		// Controls
		jlPlayerControls = get(jlPlayerElem, 'jlplayer-controls', 'class');

		// Botão Play Pause e Restart
		jlPlayerBtnPlay = get(jlPlayerControls, 'jlplayer-play', 'class');
		jlPlayerBtnPlay.innerHTML = svgIcos.play;

		// Progress
		jlPlayerProgress = get(jlPlayerControls, 'jlplayer-presentation', 'class');

		// Range Seeker
		rangeSeeker = get(jlPlayerProgress, 'input', 'tag');

		// Buffer
		progressBuffer = get(jlPlayerProgress, 'jlplayer-pbuffer', 'class');

		// Tooltip progress
		currentTimeTooltip = get(jlPlayerProgress, 'jlplayer-tooltip', 'class');

		// Progress
		progressVideo = get(jlPlayerProgress, 'jlplayer-pplayed', 'class');

		// Time total
		jlPlayerTotalTime = get(jlPlayerControls, 'jlplayer-time', 'class');

		// Volume button
		jlPlayerBtnVol = get(jlPlayerControls, 'jlplayer-vol', 'class');
		jlPlayerBtnVol.innerHTML = svgIcos.volhigh;
		icoVol = 'volhigh';

		// Volume Controls
		jlPlayerSliderVol = get(jlPlayerControls, 'jlplayer-volume', 'class');

		// Range volume
		rangeVol = get(jlPlayerSliderVol, 'input', 'tag');

		// Slider Volume
		sliderVol = get(jlPlayerSliderVol, 'jlplayer-setvolume', 'class');

		// Caption button
		jlPlayerBtnCC = get(jlPlayerControls, 'jlplayer-captions', 'class');
		jlPlayerBtnCC.innerHTML = svgIcos.cc;
		handler(jlPlayerBtnCC, 'click', setTrack, !0);

		// Fullscreen button
		jlPlayerBtnScreen = get(jlPlayerControls, 'jlplayer-screen', 'class');
		jlPlayerBtnScreen.innerHTML = svgIcos.fullscreen;

		// Eventos de seeker
		handler(jlPlayerProgress, 'mousedown', startDrag, !0);
		handler(jlPlayerSliderVol, 'mousedown', startDrag, !0);

		// eventos de audio
		handler(jlPlayerBtnVol, 'click', muteVideo, !0);
		handler(jlPlayerSliderVol, 'mousedown click mousewheel touchstart touchmove touchend', setVolume, !0);

		// Eventos de tela
		handler(jlPlayerBtnScreen, 'click', expandPlayer, !0);

		// Eventos do document
		handler(document, 'mouseup', startDrag, !0);
		handler(document, 'webkitfullscreenchange mozfullscreenchange fullscreenchange', checkFullscren, !0);

		// Eventos do vídeo
		handler(jlPlayerVideo, 'canplay', canplay, !0);
		handler(jlPlayerVideo, 'timeupdate', updateTimer, !0);
		handler(jlPlayerVideo, 'waiting canplay playing play loadstart seeked', videoLoader, !0);
		handler(jlPlayerVideo, 'ended', restartVideo, !0);

		autoCorretor();

		// Dispara se ouver erro
		handler(jlPlayerVideo, 'error', videoError, !0);

		// Atividade do mouse
		handler(jlPlayerElem, 'mousemove', checkMouseActivity, !0);
		activityMouseFull = false;

		handler(jlPlayerVideo, 'progress', progressBuffering, !0);
	}

	// Verifica a atividade do mouse em fullscreen para esconder a barra de controles
	function checkMouseActivity(evt) {

		if (!activityMouseFull) {
			activityMouseFull = true;
			var e = jlPlayerElem.className;
			jlPlayerElem.className = e.replace("jlplayer-cursor-hidden", "jlplayer-cursor-show");
		}

		var d = new Date();
		activityMouseTime = d.getTime();
	}

	function progressBuffering() {

		var d = jlPlayerVideo.duration,
			c = jlPlayerVideo.currentTime,
			buffer = jlPlayerVideo.buffered,
			bufferW = 0;

		if (d > 0) {
			for (var i = 0; i < buffer.length; i++) {
				if (buffer.start(buffer.length - 1 - i) < c) {
					progressBuffer.style.width = (buffer.end(buffer.length - 1 - i) / d) * 100 + "%";
					break;
				}
			}
		}
	}

	// Atualiza o time, progress e o buffer do vídeo
	function updateTimer(evt) {

		//Duração total do video
		var h = Math.floor(jlPlayerVideo.currentTime / 3600),
			m = Math.floor(jlPlayerVideo.currentTime / 60),
			s = Math.floor(((jlPlayerVideo.currentTime / 60) % 1) * 60);

		// Usa o metodo convertTimer para setar a duração do vídeo
		jlPlayerTotalTime.textContent = convertTimer(h, m, s);


		var pctSeek = (jlPlayerVideo.currentTime / jlPlayerVideo.duration) * 100;

		if (!sliderDrag) {
			progressVideo.style.width = pctSeek + '%';
			rangeSeeker.value = pctSeek;
		}

		// Sistema de legenda
		if (trackCaption) {
			// Seta modo da legenda para 'hidden' quando for 'showing'
			if (trackCaption.mode == 'showing') {
				trackCaption.mode = 'hidden';
				activeCaption = 'hidden';
			}

			// Se a legenda estiver ativada chama metodo de controle de legenda
			if (trackCaption.mode != 'disabled') {
				cuesControls();
			}

		}


		// Controle de atividade do mouse para esconder o menu
		var ms = new Date();
		if (activityMouseFull) {
			if (ms.getTime() > (activityMouseTime + 3000)) {
				activityMouseFull = false;

				var e = jlPlayerElem.className;
				jlPlayerElem.className = e.replace("jlplayer-cursor-show", "jlplayer-cursor-hidden");
			}
		}
	}

	// Verifica o estado do Fullscreen para trocar do icone do botão e a class jlplayer-video-fullscreen
	function checkFullscren() {
		var df = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;

		var c = jlPlayerElem.className;

		if (!df) {
			jlPlayerElem.className = c.replace('jlplayer-fullscreen-on', 'jlplayer-fullscreen-off');
			jlPlayerBtnScreen.innerHTML = svgIcos.fullscreen;
		} else {
			jlPlayerElem.className = c.replace('jlplayer-fullscreen-off', 'jlplayer-fullscreen-on');
			jlPlayerBtnScreen.innerHTML = svgIcos.restore;
		}
	}

	// Ação de reiniciar o vídeo quando acabar
	function restartVideo(evt) {
		jlPlayerBtnPlay.innerHTML = svgIcos.restart;
		var e = jlPlayerElem.className;
		jlPlayerElem.className = e.replace("jlplayer-cursor-hidden", "jlplayer-cursor-show");
		jlPlayerBtnPlayCenter.innerHTML = svgIcos.playc;
		jlPlayerBtnPlayCenter.style.display = 'block';
	}

	// Faz a correção dos elementos obrigatórios
	function autoCorretor() {
		jlPlayerElem.setAttribute('oncontextmenu', 'return false');
		jlPlayerVideo.controls = false;
		//jlPlayerVideo.setAttribute('crossorigin', '');

		/*
		if (!jlPlayerVideo.getAttribute('preload')) {
			jlPlayerVideo.preload = 'none';
		}*/

		// Remove botão de legenda se não encontrar nenhuma track...
		if (!jlPlayerElem.getElementsByTagName('track')[0]) {
			jlPlayerBtnCC.remove();
		}

		if (jlPlayerVideo.preload == 'none') {
			// Eventos de player e pause
			handler(jlPlayerBtnPlay, 'click', playVideo, !0);
			handler(jlPlayerBtnPlayCenter, 'click', playVideo, !0);
			handler(jlPlayerVideo, 'click', playVideo, !0);
			if (isTouch) {
				handler(jlPlayerVideo, 'click', playVideo, !1);
			}
		}
	}

	// Converte o tempo e retorna no formato de hh:mm:ss
	function convertTimer(hours, minutes, seconds) {
		hours = (hours < 10 && hours > 0 ? '0' + hours + ":" : '');
		minutes = ((minutes < 10) ? '0' + minutes : minutes);
		minutes = ((minutes > 59) ? (minutes - (Math.floor(minutes / 60) * 60)) : minutes);
		seconds = ((seconds < 10) ? '0' + seconds : seconds);
		return String(hours) + String(minutes) + ':' + String(seconds);
	}

	// Chamado quando ouve erro no vídeo
	function videoError() {
		jlPlayerTotalTime.textContent = '00:00';
		currentTimeTooltip.textContent = '00:00';
	}

	// Libera o arrastar dos inputs range
	function startDrag(evt) {
		if (evt.type == "mousedown") {
			sliderDrag = true;
			if (String(evt.target.className) === 'jlplayer-rangevol') {
				handler(jlPlayerSliderVol, 'mousemove', setVolume, !0);
			}
		} else {
			sliderDrag = false;
			jlPlayerSliderVol.removeEventListener('mousemove', setVolume);
		}
	}

	// Controla o volume apartir do slider
	function setVolume(evt) {

		var value = rangeVol.value,
			clientX = 0,
			ClientRect = jlPlayerSliderVol.getBoundingClientRect(),
			position = 0,
			deltaWheel = Math.max(-1, Math.min(1, evt.wheelDelta));

		if (String(evt.type) !== 'touchend') {
			clientX = (String(evt.clientX) !== 'undefined' ? evt.clientX : evt.touches[0].clientX);
			clientX = (clientX - ClientRect.left) / rangeVol.clientWidth;
		}

		// Ações e eventos
		switch (evt.type) {

			case 'touchstart':
				sliderVol.style.width = (clientX * 100) + '%';
				break;

			case 'mousemove':
				if (sliderDrag) {
					updateVolume();
				}
				break;

			case 'mousewheel':
				rangeVol.value -= (-0.1 * deltaWheel);
				value = rangeVol.value;
				updateVolume();

				break;

			default:
				updateVolume();
		}

		// Atualizar o sistema de volume
		function updateVolume() {
			if (jlPlayerVideo.muted) {
				jlPlayerVideo.muted = false;
			}

			jlPlayerVideo.volume = value;
			sliderVol.style.width = (value * 100) + '%';

			volTarget = (jlPlayerVideo.volume > 0 ? jlPlayerVideo.volume : 1);
			if (jlPlayerVideo.volume > 0) {
				if (jlPlayerVideo.volume >= 0.5) {
					if (icoVol != 'volhigh') {
						jlPlayerBtnVol.innerHTML = svgIcos.volhigh;
						icoVol = 'volhigh';
					}

				} else {
					if (icoVol != 'vollow') {
						jlPlayerBtnVol.innerHTML = svgIcos.vollow;
						icoVol = 'vollow';
					}
				}
			} else {
				jlPlayerVideo.muted = true;
				if (icoVol != 'volmute') {
					jlPlayerBtnVol.innerHTML = svgIcos.volmute;
					icoVol = 'volmute';
				}
			}
		}
	}

	// Controla o seeker do vídeo apartir do slider
	function setSeeker(evt) {

		var clientX = (String(evt.clientX) !== 'undefined' ? evt.clientX : evt.touches[0].clientX);

		var ClientRect = jlPlayerProgress.getBoundingClientRect(),
			value = (clientX - ClientRect.left) / rangeSeeker.clientWidth,
			cH = Math.floor((value * jlPlayerVideo.duration) / 3600),
			cM = Math.floor((value * jlPlayerVideo.duration) / 60),
			cS = Math.floor((((value * jlPlayerVideo.duration) / 60) % 1) * 60);

		currentTimeTooltip.textContent = convertTimer(cH, cM, cS);
		currentTimeTooltip.style.left = (value * 100) + '%';

		switch (evt.type) {
			case 'mousemove':
				if (sliderDrag) {
					progressVideo.style.width = (value * 100) + '%';
					updateSeeker();
				}
				break;
			case 'touchmove':
				progressVideo.style.width = (value * 100) + '%';
				updateSeeker();
				break;
			default:
				updateSeeker();
		}

		// Seta a nova posição do seeker
		function updateSeeker() {
			rangeSeeker.value = (value * 100);
			progressVideo.style.width = (value * 100) + '%';
			jlPlayerVideo.currentTime = (value * jlPlayerVideo.duration);
		}
	}

	// Controle do botão de volume
	function muteVideo() {
		if (!jlPlayerVideo.muted) {
			volTarget = (jlPlayerVideo.volume > 0 ? jlPlayerVideo.volume : 1);
			jlPlayerVideo.muted = true;
			jlPlayerVideo.volume = 0;
			jlPlayerBtnVol.innerHTML = svgIcos.volmute;
			icoVol = 'volmute';
			rangeVol.value = 0;
			sliderVol.style.width = 0;
		} else {
			jlPlayerVideo.muted = false;
			jlPlayerVideo.volume = volTarget;
			rangeVol.value = volTarget;
			sliderVol.style.width = (volTarget * 100) + '%';
			if (jlPlayerVideo.volume >= 0.5) {
				jlPlayerBtnVol.innerHTML = svgIcos.volhigh;
				icoVol = 'volhigh';
			} else {
				jlPlayerBtnVol.innerHTML = svgIcos.vollow;
				icoVol = 'vollow';
			}
		}
	}

	// Ações de play e pause do vídeo
	function playVideo(evt) {

		var e = String(evt.target.tagName);
		if (isTouch && e.toLowerCase() === 'video') {
			return false;
		}

		if (jlPlayerVideo.played.length != 0) {
			if (jlPlayerVideo.paused) {
				played = true;
				jlPlayerVideo.play();
				jlPlayerBtnPlay.innerHTML = svgIcos.pause;
				jlPlayerBtnPlayCenter.innerHTML = svgIcos.pausec;
				if (!isTouch) {
					jlPlayerBtnPlayCenter.style.display = 'none';
				}
			} else {
				played = false;
				jlPlayerVideo.pause();
				jlPlayerBtnPlay.innerHTML = svgIcos.play;
				jlPlayerBtnPlayCenter.innerHTML = svgIcos.playc;
				if (!isTouch) {
					jlPlayerBtnPlayCenter.style.display = 'block';
				}

			}
		} else {
			played = true;
			jlPlayerVideo.play();
			jlPlayerBtnPlay.innerHTML = svgIcos.pause;
			jlPlayerBtnPlayCenter.innerHTML = svgIcos.pausec;
			if (!isTouch) {
				jlPlayerBtnPlayCenter.style.display = 'none';
			}
		}
	}

	// Chamado quando o vídeo pode ser reproduzido
	function canplay(evt) {

		played = true;

		//Duração total do video
		var h = Math.floor(jlPlayerVideo.duration / 3600),
			m = Math.floor(jlPlayerVideo.duration / 60),
			s = Math.floor(((jlPlayerVideo.duration / 60) % 1) * 60);

		// Usa o metodo convertTimer para setar a duração do vídeo
		jlPlayerTotalTime.textContent = convertTimer(h, m, s);

		// CurrentTime
		var cH = Math.floor(jlPlayerVideo.currentTime / 3600),
			cM = Math.floor(jlPlayerVideo.currentTime / 60),
			cS = Math.floor(((jlPlayerVideo.currentTime / 60) % 1) * 60);


		// Usa o metodo convertTimer para setar a o tempo de andamento do vídeo
		currentTimeTooltip.textContent = convertTimer(cH, cM, cS);

		// Eventos de seeker
		handler(jlPlayerProgress, 'mousedown mouseup mousemove touchstart touchmove', setSeeker, !0);

		// Faz a leitura do track da primeira legenda
		trackCaption = jlPlayerVideo.textTracks[0];

		// Verifica se existra track de legenda
		if (trackCaption) {
			trackCaption.mode = activeCaption;
		}


		// Eventos de player e pause
		handler(jlPlayerBtnPlay, 'click', playVideo, !0);
		handler(jlPlayerBtnPlayCenter, 'click', playVideo, !0);
		handler(jlPlayerVideo, 'click touchstart', playVideo, !0);

		// Remove evento click se existir touch
		if (isTouch) {
			handler(jlPlayerVideo, 'click', playVideo, !1);
		}

	}

	// e = Elemento - t = tipos de eventos separados por espaço - f = função chamada - c = capture - r = addEventListener ou removeEventListener
	function handler(e, t, f, r, c) {
		var s = t.split(" ");
		for (var i = 0; i < s.length; i++) {
			e[r ? "addEventListener" : "removeEventListener"](s[i], f, c);
		}
	}

	// getElementBy - e = elemento container - a = qual atributo - v = valor do atributo - i = indice
	function get(e, v, a, i) {
		i = !i ? 0 : i;
		switch (a) {
			case 'class':
				return e["getElementsByClassName"](v)[i];
				break;
			case 'tag':
				return e["getElementsByTagName"](v)[i];
				break;
			default:
				return e["getElementById"](v);
		}
	}

	// Loader do player
	function videoLoader(evt) {
		if (played) {
			if (evt.type == 'waiting' || evt.type == 'loadstart') {
				jlPlayerLoader.style.display = 'block';
			} else {
				jlPlayerLoader.style.display = 'none';
			}
		}
	}

	// Sistema de fullscreen
	function expandPlayer() {

		var df, rf, ef;

		// fullscreenElement
		df = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;

		// requestFullscreen
		rf = jlPlayerElem.requestFullscreen || jlPlayerElem.msRequestFullscreen || jlPlayerElem.mozRequestFullScreen || jlPlayerElem.webkitRequestFullscreen;

		//exitFullscreen
		ef = document.exitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen;

		if (!df) {
			rf.call(jlPlayerElem);
		} else {
			ef.call(document);
		}
	}

	// Ativa e desativa a legenda
	function setTrack() {

		if (trackCaption) {
			if (trackCaption.mode == 'disabled') {
				trackCaption.mode = 'hidden';
				activeCaption = 'hidden';
				jlPlayerBtnCC.className = 'jlplayer-captions';
			} else {
				trackCaption.mode = 'disabled';
				activeCaption = 'disabled';
				jlPlayerBtnCC.className = 'jlplayer-captions disabled';
				jlPlayerLegends.innerHTML = '<span></span>';
			}
		}
	}

	// Atualiza o texto da legenda quando disponivel
	function cuesControls() {

		cuesTrack = trackCaption.activeCues;

		if (cuesTrack) {
			if (cuesTrack.length > 0) {
				if (cuesText !== cuesTrack[0].getCueAsHTML().textContent)
					cuesText = cuesTrack[0].getCueAsHTML().textContent;
				jlPlayerLegends.innerHTML = '<span>' + cuesText + '</span>';
			} else {
				if (cuesText !== '') {
					cuesText = '';
					jlPlayerLegends.innerHTML = '<span></span>';
				}
			}
		}
	}

	// Chama o metodo de construção
	construct();
}

var WhatsApp = {
	init: function () {
		this.details()
	},

	details: function () {
		var button = $('.js-open-whatsapp'),
			content = $('.js-whatsapp-content')

		if (button.length > 0) {
			button.click(function (e) {
				e.preventDefault()
				content.toggleClass('opened')
			});
		}

	}
}

WhatsApp.init();

function copiarTexto() {
	var textoCopiado = $(".js-copy-url")[0];
	textoCopiado.select();
	textoCopiado.setSelectionRange(0, 99999)
	document.execCommand("copy");
	console.log(textoCopiado);
}

//# sourceMappingURL=custom.js.map

//# sourceMappingURL=custom.js.map
